import axios from 'axios';

export const findUserInfo = (headers) => {
  return axios.get(`${process.env.REACT_APP_SECURITY_API_URL}/userinfo`, {
    headers,
  });
};
